import { render, staticRenderFns } from "./ExportationsLeadStatus.vue?vue&type=template&id=67049de0&scoped=true&"
import script from "./ExportationsLeadStatus.vue?vue&type=script&lang=ts&"
export * from "./ExportationsLeadStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ExportationsLeadStatus.vue?vue&type=style&index=0&id=67049de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67049de0",
  null
  
)

export default component.exports